import StarIcon from 'assets/images/icons/star.svg?react';
import { useTranslation } from 'react-i18next';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import {
  AverageRatingReviewsContainer,
  OverallRatingContainer,
} from './OverallRating.styles';

const OverallRating = ({
  reviewsAmount,
  averageRating,
  title,
  isLoading,
}: {
  reviewsAmount: number;
  averageRating: number;
  title: string;
  isLoading?: boolean;
}) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <OverallRatingContainer>
        <h3>{title}</h3>
        <LoadingPlaceholder width="150px" />
      </OverallRatingContainer>
    );
  }

  return (
    <OverallRatingContainer>
      <h3>{title}</h3>

      <AverageRatingReviewsContainer>
        <StarIcon />
        <span data-testid="overall-rating-reviews-value">
          {Number(averageRating || 0).toFixed(2)}
        </span>
        <div className="separator" />
        <span data-testid="overall-rating-reviews-amount">
          {t('pageProperty.reviews.reviews', { count: reviewsAmount || 0 })}
        </span>
      </AverageRatingReviewsContainer>
    </OverallRatingContainer>
  );
};

OverallRating.defaultProps = {
  isLoading: false,
};

export default OverallRating;
